import React from 'react';

import cn from 'classnames';

import './info-message.component.scss';

const InfoMessage = ({ handleClose, infoMessage }) => (
	<div className={cn('info-label', { active: infoMessage }, infoMessage ? infoMessage.type : null)}>
		<div className="container container-fluid">
			<div className="label">
				<span className="label-message">{infoMessage ? infoMessage.message : '...'}</span>
				<div className="close" onClick={handleClose} />
			</div>
		</div>
	</div>
);

export default InfoMessage;
